import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_box_list = _resolveComponent("product-box-list")!

  return (_openBlock(), _createBlock(_component_product_box_list, {
    products: _ctx.products,
    "tracking-list": "containedInSet",
    "hide-cart-button": false
  }, null, 8 /* PROPS */, ["products"]))
}